import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

/**
 * The email settings in the `setting` row (api/auto-emails), shared by SMTP Settings and
 * Appointment Emails & Canned Replies. Each page saves only its own fields.
 */
@Injectable({ providedIn: 'root' })
export class EmailSettingsService {
    constructor(private http: HttpClient) { }

    /** Every field, nulls as ''; passwordSet says whether an SMTP password is saved (never sent). */
    load(): Observable<{ values: any, passwordSet: boolean }> {
        return this.http.get<any>(environment.api + 'auto-emails').pipe(map(res => {
            const values: any = {};
            Object.keys(res).forEach(k => values[k] = res[k] === null ? '' : res[k]);
            const passwordSet = !!values.smtp_password_set;
            delete values.smtp_password_set;
            return { values, passwordSet };
        }));
    }

    save(fields: { [field: string]: any }): Observable<any> {
        return this.http.put<any>(environment.api + 'auto-emails', fields);
    }

    /** Messages for blank required fields: { field: 'Label is required.' }. */
    blanks(values: any, required: { [field: string]: string }): { [field: string]: string } {
        const errors: { [field: string]: string } = {};
        Object.keys(required).forEach(k => {
            const v = values[k];
            if (!String(v === null || v === undefined ? '' : v).trim()) {
                errors[k] = required[k] + ' is required.';
            }
        });
        return errors;
    }
}
